import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  VStack,
  Button,
  Text,
  Select,
} from '@chakra-ui/react';
import { useGame } from '../../contexts/GameContext.tsx';
// L'import local de 'categories' est maintenant supprimé
import { useTranslation } from 'react-i18next';

interface MysteryTargetSelectorProps {
  isOpen: boolean;
  onClose: () => void;
  onTargetSelected: () => void;
}

const MysteryTargetSelector: React.FC<MysteryTargetSelectorProps> = ({ isOpen, onClose, onTargetSelected }) => {
  const { t } = useTranslation();
  const { state, selectMysteryTarget } = useGame();
  const [selectedPlayer, setSelectedPlayer] = React.useState<string>('');

  const currentPlayer = state.players[state.currentPlayerIndex];
  const otherPlayers = state.players.filter(p => p.id !== currentPlayer.id);
  
  const playersWithStreak = otherPlayers.filter(player => 
    Object.entries(player.score).some(([categoryId, score]) => {
      const category = state.categories.find(c => c.id === categoryId); // Utilise state.categories
      if (!category || category.is_mystery) return false;
      const isCompleted = player.completedCategories.includes(categoryId);
      return score > 0 && !isCompleted;
    })
  );

  const handleSubmit = () => {
    if (selectedPlayer && selectMysteryTarget) {
      // Le système choisira automatiquement la catégorie avec le score le plus élevé
      selectMysteryTarget(parseInt(selectedPlayer));
      onTargetSelected();
      onClose();
      setSelectedPlayer('');
    }
  };

  React.useEffect(() => {
    // Reset player selection when modal opens
    if (isOpen) {
      setSelectedPlayer('');
    }
  }, [isOpen]);

  const availableCategories = [];

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent 
        bg="var(--gris-bleute)" 
        color="var(--texte-clair)"
        border="1px solid"
        borderColor="rgba(139, 148, 179, 0.2)"
      >
        <ModalHeader color="var(--magenta-vif)">{t('mysteryQuestionTitle')}</ModalHeader>
        <ModalBody>
          <VStack spacing={4} pb={4}>
            <Text textAlign="center">
              {t('mysteryQuestionDesc', { name: currentPlayer.name })}
            </Text>
            
            <Text textAlign="center" fontSize="sm" color="gray.400">
              {t('mysteryAutoTargetExplanation') || 'La catégorie avec le score le plus élevé sera automatiquement ciblée.'}
            </Text>

            <Select
              placeholder={t('selectPlayerPlaceholder')}
              value={selectedPlayer}
              onChange={(e) => setSelectedPlayer(e.target.value)}
              bg="var(--nuit-profonde)"
              borderColor="rgba(139, 148, 179, 0.2)"
              _focus={{ borderColor: 'var(--bleu-electrique)' }}
            >
              {playersWithStreak.map(player => (
                <option key={player.id} value={player.id} style={{ backgroundColor: 'var(--nuit-profonde)' }}>
                  {player.name}
                </option>
              ))}
            </Select>

            {playersWithStreak.length === 0 && (
              <Text color="red.400" fontSize="sm">
                {t('noActiveStreakForPlayer')}
              </Text>
            )}

            <Button
              colorScheme="red"
              isDisabled={!selectedPlayer}
              onClick={handleSubmit}
              w="full"
            >
              {t('confirmButton')}
            </Button>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default MysteryTargetSelector;